import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="drawer-tabs"
// Generic tab switching for drawers. Works with the DrawerComponent tab_bar slot.
// Tab buttons use data-drawer-tabs-target="tab" data-tab="name"
// Tab panels use data-drawer-tabs-target="tabPanel" data-tab="name"
export default class extends Controller {
  static targets = ["tab", "tabPanel"]

  connect() {
    this.updateTabs()
  }

  select(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    if (tab === this.activeTab) return

    this.activeTab = tab
    this.updateTabs()
  }

  reset() {
    this.activeTab = this.tabTargets[0]?.dataset.tab || "summary"
    this.updateTabs()
  }

  get activeTab() {
    return this._activeTab || this.tabTargets[0]?.dataset.tab || "summary"
  }

  set activeTab(value) {
    this._activeTab = value
  }

  updateTabs() {
    const active = this.activeTab

    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.tab === active)
    })

    this.tabPanelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== active)
    })
  }
}
